exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-main-tabs{position:relative;height:53px}.clinic-main-tabs>div:not(.tab-content){background-color:var(--theme-grey-bg)}.clinic-main-tabs .nav-tabs{max-width:1140px;margin:auto}.clinic-main-tabs .nav-tabs .nav-link{font-size:14px}.clinic-main-tabs .nav-tabs:after,.clinic-main-tabs .nav-tabs:before{position:absolute;background-color:var(--theme-grey-bg);top:0;left:-99em;width:99em;height:52px;display:block;content:\"\"}.clinic-main-tabs .nav-tabs:before{left:-99em}.clinic-main-tabs .nav-tabs:after{left:100%}", ""]);

// exports
